module.exports = __webpack_public_path__ + "img/public/SiteIcons/shareIcon.svg?ac65cb74";